import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 22H14V20H10V22ZM13 3.083V2H11V3.083C8.164 3.56 6 6.029 6 9V11.691L4 14.698V18H20V14.697L18 11.697V9C18 6.029 15.836 3.56 13 3.083ZM12 5C9.792 5 8 6.792 8 9V12.295L6 15.302V16H18V15.303L16 12.303V9C16 6.792 14.208 5 12 5Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}